export default __webpack_public_path__ + "dist/media/WordExcel.0f9bb68d.svg";